// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__NoKJv","title":"Images45_title__3BohP","images":"Images45_images__1NZCN"};